import { MdOutlineAdd, MdOutlineRemove } from 'react-icons/md';
import { IoMdTrash } from 'react-icons/io';

import QuantityButton from './components/QuantityButton';
import { QuantityChangeEvents } from 'features/events/checkout/types';

type Props = {
  selectedTicketTierQuantity: number;
  onQuantityChange: (event: QuantityChangeEvents) => void;
  totalAmountOfTicketsSelected: number;
  maxTicketsPerTransaction: number;
  remainingTicketsForTier: number;
};

const QuantityButtons = ({
  selectedTicketTierQuantity,
  onQuantityChange,
  totalAmountOfTicketsSelected,
  maxTicketsPerTransaction,
  remainingTicketsForTier
}: Props) => {
  const updateQuantity = (event: QuantityChangeEvents) => () => {
    onQuantityChange(event);
  };

  if (selectedTicketTierQuantity === 0) {
    return (
      <div className="bg-black text-white rounded-full flex align-center justify-center h-[30px] w-[30px]">
        <MdOutlineAdd size={24} />
      </div>
    );
  }

  return (
    <div className="bg-black text-white rounded-3xl flex align-center justify-center">
      <QuantityButton
        onClick={updateQuantity(QuantityChangeEvents.Decrease)}
        disabled={totalAmountOfTicketsSelected <= 0}
      >
        {selectedTicketTierQuantity === 1 ? (
          <IoMdTrash size={24} className="ml-1" />
        ) : (
          <MdOutlineRemove size={24} />
        )}
      </QuantityButton>
      <div className="text-lg font-normal">
        {String(selectedTicketTierQuantity).padStart(2, '0')}
      </div>
      <QuantityButton
        disabled={
          totalAmountOfTicketsSelected >= maxTicketsPerTransaction ||
          selectedTicketTierQuantity >= remainingTicketsForTier
        }
        onClick={updateQuantity(QuantityChangeEvents.Increase)}
      >
        <MdOutlineAdd size={24} />
      </QuantityButton>
    </div>
  );
};
export default QuantityButtons;
